import { motion } from "framer-motion";
import buildingFront from "@/assets/building-front.png";
import { Mail, Phone, MapPin } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-end overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={buildingFront}
          alt="Urbanova Apartment Building - Modern architecture in Skopje"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-16 pb-16 md:pb-24 pt-32">
        <div className="max-w-6xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-primary-foreground/60 font-body text-sm tracking-[0.3em] uppercase mb-4"
          >
            Apartment rental · Skopje, Macedonia
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-primary-foreground leading-[0.95] mb-6"
          >
            Urbanova
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-primary-foreground/80 font-body text-lg md:text-xl max-w-xl mb-8"
          >
            A modern apartment with mountain views, steps from everything Skopje has to offer.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.45 }}
            className="flex flex-wrap items-center gap-4"
          >
            <div className="flex items-center gap-3 bg-primary-foreground/10 backdrop-blur-md border border-primary-foreground/20 rounded-lg px-6 py-4">
              <span className="text-primary-foreground text-3xl font-heading font-bold">from €40</span>
              <span className="text-primary-foreground/50 text-sm font-body">/ night</span>
            </div>
            <a
              href="#contact"
              className="bg-primary-foreground text-primary font-body font-semibold px-8 py-4 rounded-lg hover:opacity-90 transition-opacity text-sm tracking-wide uppercase"
            >
              Book Now
            </a>
            <a
              href="https://booking.com"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-primary-foreground/30 text-primary-foreground font-body font-medium px-6 py-4 rounded-lg hover:bg-primary-foreground/10 transition-colors text-sm tracking-wide"
            >
              Booking.com
            </a>
            <a
              href="https://airbnb.com"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-primary-foreground/30 text-primary-foreground font-body font-medium px-6 py-4 rounded-lg hover:bg-primary-foreground/10 transition-colors text-sm tracking-wide"
            >
              Airbnb
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 1.8 }}
          className="w-5 h-8 border-2 border-primary-foreground/40 rounded-full flex justify-center pt-1.5"
        >
          <div className="w-1 h-1.5 bg-primary-foreground/60 rounded-full" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
